import { getOfferById } from '../../../reducers/offers';

export default state => {
  if (!state.selection || !state.selection.offerId) {
    return null;
  }
  const selectedId = state.selection.offerId;
  const selectedOffer = getOfferById(state.offers, selectedId);

  // User no longer has access to the selected offer (they upgraded), so return null for sub looking to move to
  if (!selectedOffer) {
    return null;
  }

  return selectedOffer.family;
};
